import { createContext } from "react";

export const ReportModalContext = createContext({});